/* eslint-disable react/prop-types */
import React, {Component} from 'react'

import PropTypes from 'prop-types'

import FeedArticles from './FeedArticles/index.js'

const EMPTY_CARD_POSITION = 3
const IMAGES_ASPECT_RATIO = '16:9'
const LOADING_IMAGES_TIMEOUT = 500
const VISIBLE_CARD_CLASSNAME = 'is-visible'
const ANIMATED_CARD_CLASSNAME = 'is-coming-in'
const BREAKPOINTS = ['s', 'l']

const isVisible = element => {
  const {top: elementTop} = element.getBoundingClientRect()
  const windowTop = document.documentElement.scrollTop
  const {innerHeight: windowBottom} = window

  return elementTop > windowTop && elementTop <= windowBottom && !element.classList.contains(VISIBLE_CARD_CLASSNAME)
}

class FeedArticlesContainer extends Component {
  constructor({i18n, domain}) {
    super({i18n, domain})

    this._articles = []
    this._scrollingElement = null
    this._breakpoints = domain.get('config').get('breakpoints')
    this._masonryBreakpoints = BREAKPOINTS.map(bp => this._breakpoints[bp].replace('px', ''))
  }

  componentDidMount() {
    const {scrollingElementSelector} = this.props

    this._scrollingElement = scrollingElementSelector ? document.querySelector(scrollingElementSelector) : window

    this._scrollingElement.addEventListener('scroll', this._setArticlesClassNames.bind(this, ANIMATED_CARD_CLASSNAME))
  }

  componentWillUnmount() {
    this._scrollingElement.removeEventListener(
      'scroll',
      this._setArticlesClassNames.bind(this, ANIMATED_CARD_CLASSNAME)
    )
  }

  handleOnSetFeeds = () => {
    this._articles = document.querySelectorAll('.mt-FeedArticles-item')
    setTimeout(() => {
      this._setArticlesClassNames()
    }, LOADING_IMAGES_TIMEOUT)
  }

  _setArticlesClassNames = (className = VISIBLE_CARD_CLASSNAME) => {
    const articlesArray = Array.prototype.slice.call(this._articles)
    articlesArray.forEach(article => {
      isVisible(article) && article.classList.add(className)
    })
  }

  render() {
    const {
      initialNewsSearchFeed: {items},
      linkFactory,
      renderCardActions,
      showInlineAd
    } = this.props

    return (
      <div>
        <FeedArticles
          feed={items}
          imagesAspectRatio={IMAGES_ASPECT_RATIO}
          emptyCardPosition={EMPTY_CARD_POSITION}
          linkFactory={linkFactory}
          breakPoints={this._masonryBreakpoints}
          onColumnsReady={this.handleOnSetFeeds}
          renderCardActions={renderCardActions}
          showInlineAd={showInlineAd}
        />
      </div>
    )
  }
}

FeedArticlesContainer.displayName = 'FeedArticles'

FeedArticlesContainer.propTypes = {
  initialNewsSearchFeed: PropTypes.shape({
    items: PropTypes.array
  }),
  scrollingElementSelector: PropTypes.string,
  linkFactory: PropTypes.func,
  renderCardActions: PropTypes.func,
  showInlineAd: PropTypes.bool,
  i18n: PropTypes.object,
  domain: PropTypes.object
}

FeedArticlesContainer.defaultProps = {
  initialNewsSearchFeed: {items: []}
}

export default FeedArticlesContainer
